import { useEffect, useState } from 'react';
import {
  GetIceServerConfigCommand,
  KinesisVideoSignalingClient,
  IceServer,
} from '@aws-sdk/client-kinesis-video-signaling';
import { ConfigOptions } from './types';
import { ERROR_ICE_SERVERS_RESPONSE } from './constants';
import { logger } from '../../../API/services/SharedService';

export function useIceServers(
  config: ConfigOptions & {
    channelEndpoint: string | undefined;
    retryCount?: any;
  },
): {
    error: Error | undefined;
    iceServers: RTCIceServer[] | undefined;
  } {
  const {
    channelARN,
    channelEndpoint,
    credentials: { accessKeyId = '', secretAccessKey = '', sessionToken = undefined } = {},
    region,
    retryCount,
  } = config;
  const [error, setError] = useState<Error>();
  const [iceServers, setIceServers] = useState<RTCIceServer[]>();

  useEffect(() => {
    if (!channelEndpoint) {
      return undefined;
    }
    console.log('iceserver');
    let isCancelled = false;

    const kinesisVideoSignalingChannelsClient = new KinesisVideoSignalingClient(
      {
        region,
        credentials: {
          accessKeyId,
          secretAccessKey,
          sessionToken,
        },
        endpoint: channelEndpoint,
        // useDualstackEndpoint: true,
      },
    );

    const getIceServerConfigCommand = new GetIceServerConfigCommand({
      ChannelARN: channelARN,
    });

    kinesisVideoSignalingChannelsClient
      .send(getIceServerConfigCommand)
      .then((getIceServerConfigResponse) => {
        if (!getIceServerConfigResponse) {
          throw new Error(ERROR_ICE_SERVERS_RESPONSE);
        }

        if (!getIceServerConfigResponse.IceServerList) {
          throw new Error(ERROR_ICE_SERVERS_RESPONSE);
        }

        const dict: RTCIceServer[] = [
          { urls: `stun:stun.kinesisvideo.${region}.amazonaws.com:443` },
        ];

        getIceServerConfigResponse?.IceServerList?.forEach(
          (iceServer: IceServer) => {
            if (!iceServer.Uris) {
              return;
            }
            dict.push({
              urls: iceServer.Uris,
              username: iceServer.Username,
              credential: iceServer.Password,
            });
          },
        );

        return dict;
      })
      .then((servers) => {
        if (isCancelled) {
          return;
        }
        setIceServers(servers);
      })
      .catch(
        logger.withErrorLog((err) => {
          if (isCancelled) {
            return;
          }
          setError(err);
        }),
      );

    return (): void => {
      isCancelled = true;
    };
  }, [accessKeyId, channelARN, channelEndpoint, region, secretAccessKey, retryCount]);

  return { error, iceServers };
}
